import styled from 'styled-components';

const Wrapper = styled.div`
  background: #f6f8f8;
  min-height: 100vh;

  /* Page Header */
  .page-header {
    background: linear-gradient(135deg, #f0f4f4 0%, #e8f0f0 100%);
    padding: 3rem 1.5rem;
    margin-bottom: 0;
  }

  .page-header .breadcrumb {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-size: 0.875rem;
    color: #6b7280;
    margin-bottom: 1rem;
  }

  .page-header .breadcrumb a {
    color: #6b7280;
    text-decoration: none;
    transition: color 0.2s;
  }

  .page-header .breadcrumb a:hover {
    color: #111718;
  }

  .page-header .breadcrumb span {
    color: #111718;
    font-weight: 500;
  }

  .page-header h1 {
    font-family: 'Playfair Display', serif;
    font-size: 2.5rem;
    font-weight: 700;
    color: #111718;
    margin: 0;
  }

  @media (min-width: 768px) {
    .page-header h1 {
      font-size: 3rem;
    }
  }

  @media (min-width: 1024px) {
    .page-header {
      padding: 3rem 3rem;
    }
    .page-header h1 {
      font-size: 3.5rem;
    }
  }

  /* Main Content */
  .products-container {
    max-width: 1440px;
    margin: 0 auto;
    padding: 3rem 1.5rem;
  }

  @media (min-width: 1024px) {
    .products-container {
      padding: 3rem;
    }
  }

  .products {
    display: flex;
    flex-direction: column;
    gap: 2.5rem;
  }

  @media (min-width: 1024px) {
    .products {
      flex-direction: row;
      gap: 2.5rem;
    }
  }

  /* Sidebar / Filters */
  .filters-section {
    width: 100%;
    flex-shrink: 0;
  }

  @media (min-width: 1024px) {
    .filters-section {
      width: 260px;
      border-right: 1px solid #e5e7eb;
      padding-right: 2rem;
    }
  }

  /* Products Section */
  .products-section {
    flex: 1;
    min-width: 0;
  }
`;

export default Wrapper;
